import React, { useState } from "react";
import axios from "axios";
import "./faculty.css";
import { resources } from "../../Resourses/Resources";

const departments = [
  "CSE",
  "ECE",
  "EEE",
  "MECH",
  "AI&DS",
  "AIML",
  "MBA",
  "S&H",
  "POLYTECHNIC",
];

const SingleFacultyUpload = () => {
  const [newFaculty, setNewFaculty] = useState({
    photoPath: "",
    faculty_name: "",
    designation: "",
    qualifications: "",
    totalExperience: "",
    email: "",
    status: "",
    phoneNumber: "",
    department: "",
    facultyId: "",
    dateOfJoin: "",
    photoName: "",
    fileName: "",
    filePath: "",
  });

  const [photo, setPhoto] = useState(null);
  const [file, setFile] = useState(null);
  const [facultyByDepartment, setFacultyByDepartment] = useState({});

  const handleInputChange = (field, value) => {
    setNewFaculty({ ...newFaculty, [field]: value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setPhoto(file);
    setNewFaculty((prev) => ({
      ...prev,
      photoName: file?.name || "",
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setNewFaculty((prev) => ({
      ...prev,
      fileName: file?.name || "",
    }));
  };

  const handleAddFaculty = async (e) => {
    e.preventDefault();

    const jsonBlob = new Blob([JSON.stringify(newFaculty)], {
      type: "application/json",
    });

    const formData = new FormData();
    formData.append("file", photo);
    formData.append("facultyDetails", jsonBlob);
    formData.append("file", file);

    try {
      const res = await axios.post(
        `${resources.APPLICATION_URL}faculty/saveFacultyDetails`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Group by department
      const dept = newFaculty.department;
      setFacultyByDepartment((prev) => {
        const updatedDept = prev[dept]
          ? [...prev[dept], newFaculty]
          : [newFaculty];
        return { ...prev, [dept]: updatedDept };
      });

      // Reset form
      setNewFaculty({
        photoPath: "",
        faculty_name: "",
        designation: "",
        qualifications: "",
        totalExperience: "",
        email: "",
        status: "",
        phoneNumber: "",
        department: "",
        facultyId: "",
        doj:"",
        // dateOfJoin: "",
        photoName: "",
        fileName: "",
        filePath: "",
      });
      setPhoto(null);
      setFile(null);

      alert("Faculty Added Successfully");
    } catch (error) {
      console.error("Error adding faculty:", error);
    }
  };

  return (
    <div className="faculty-form">
      <h3 style={{ color: "black" }}>Add New Faculty</h3>
      <form
        onSubmit={handleAddFaculty}
        className="facultyFormBox"
        encType="multipart/form-data"
      >
        <label>Faculty Name</label>
        <input
          type="text"
          value={newFaculty.faculty_name}
          onChange={(e) => handleInputChange("faculty_name", e.target.value)}
          required
        />

        <label>Designation</label>
        <input
          type="text"
          value={newFaculty.designation}
          onChange={(e) => handleInputChange("designation", e.target.value)}
          required
        />

        <label>Qualifications</label>
        <input
          type="text"
          value={newFaculty.qualifications}
          onChange={(e) => handleInputChange("qualifications", e.target.value)}
          required
        />

        <label>Total Experience (Years)</label>
        <input
          type="number"
          value={newFaculty.totalExperience}
          onChange={(e) => handleInputChange("totalExperience", e.target.value)}
          required
        />

        <label>Email</label>
        <input
          type="email"
          value={newFaculty.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          required
        />

        <label>Status</label>
        <input
          type="text"
          value={newFaculty.status}
          onChange={(e) => handleInputChange("status", e.target.value)}
          required
        />

        <label>Phone Number</label>
        <input
          type="text"
          value={newFaculty.phoneNumber}
          onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
          required
        />

        <label>Department</label>
        <select
          value={newFaculty.department}
          onChange={(e) => handleInputChange("department", e.target.value)}
          required
        >
          <option value="">Select Department</option>
          {departments.map((dept) => (
            <option key={dept} value={dept}>
              {dept}
            </option>
          ))}
        </select>

        <label>Faculty ID</label>
        <input
          type="text"
          value={newFaculty.facultyId}
          onChange={(e) => handleInputChange("facultyId", e.target.value)}
          required
        />

        <label>Date of Joining</label>
        <input
          type="date"
          value={newFaculty.doj || ""}
          onChange={(e) => handleInputChange("doj", e.target.value)}
          required
        />

        <label>Upload Faculty Photo</label>
        <input
          type="file"
          accept="image/*"
          onChange={handlePhotoChange}
          required
        />

        <label>Upload Faculty Document (PDF or DOCX)</label>
        <input
          type="file"
          accept=".pdf, .doc, .docx"
          onChange={handleFileChange}
          required
        />

        <button type="submit" className="submitFacultyBtn">
          Add Faculty
        </button>
      </form>

      <hr />
      {/* 
      <div className="facultyList">
        <h3>Faculty by Department</h3>
        {departments.map((dept) => (
          <div key={dept}>
            <h4>{dept}</h4>
            <ul>
              {(facultyByDepartment[dept] || []).map((faculty, index) => (
                <li key={index}>
                  {faculty.faculty_name} - {faculty.designation}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default SingleFacultyUpload;
